<template>
	<div>
		<div class="specs-list">
			<van-cell class="specs-list-item" v-for="(item, index) in list" :class="item.default == 1 ? 'active' : ''"
				:value="item.name" :key="index" :border="false" @click="changeSpecsIndex(item.id)">
				<!-- 使用 title 插槽来自定义标题 -->
				<template #title>

					<!-- 有会员价 -->
					<template v-if="isHasVipPrice(item.amount_membership)">
						<!-- 可以使用会员价购买 -->
						<template v-if="isVipPricePower">
							<span class="symbol" style="font-weight: bold;">会员价￥</span>
							<span class="number">{{ clearPriceZero(item.amount_membership) }}</span>
							<span class="old-number">￥{{ clearPriceZero(item.amount) }}</span>
						</template>

						<!-- 不可以使用会员价购买 -->
						<template v-else>
							<span class="symbol">￥</span>
							<span class="number">{{ clearPriceZero(item.amount) }}</span>
							<span class="vip-number">会员价¥{{ clearPriceZero(item.amount_membership) }}</span>
						</template>
					</template>

					<!-- 没有会员价格 -->
					<template v-else>
						<span class="symbol">￥</span>
						<span class="number">{{ clearPriceZero(item.amount) }}</span>
					</template>
				</template>
			</van-cell>
			<van-button round type="primary" class="button" @click="confirm">确定</van-button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		list: {
			type: Array,
			default: () => [],
		},
		no: String,
		isVipPricePower: Boolean
	},
	data() {
		return {
			listIndex: 0,
		}
	},
	computed: {
		isHasVipPrice() {
			return function (price) {
				return !!price && price !== '0.00'
			}
		},
		clearPriceZero() {
			return function (price) {
				return this.$util.clearPriceZero(price)
			}
		}
	},
	methods: {
		changeSpecsIndex(id) {
			let list = JSON.parse(JSON.stringify(this.list))
			list.forEach((item) => {
				if (item.id == id) {
					item.default = 1
				} else {
					item.default = 0
				}
			})
			this.$emit('change', list)
		},
		confirm() {
			this.$emit('confirmClick', this.no)
		},
	},
}
</script>

<style lang="scss" scoped>
.van-button {
	width: 100%;
}

.specs-list {
	&-item {
		align-items: center;
		padding: 0 0.64rem;
		height: 1.33rem;
		border-radius: 0.2rem;
		margin-bottom: 0.48rem;
		background: #f7f8fa;
		border: none;
		border: 1px solid transparent;

		&.active {
			border: 1px solid #89dfbf;
			background: #f3fcf9;
		}

		.van-cell {
			&__title {
				font-size: 0.37rem;

				.number {
					font-size: 0.53rem;
					font-weight: bold;
				}

				.vip-number {
					display: inline-block;
					margin-left: .2rem;
					font-size: 0.35rem;
					font-weight: 500;
					color: #E5B66E;
				}

				.old-number {
					font-size: 0.37rem;
					color: #919499;
					text-decoration: line-through;
					display: inline-block;
					margin-left: .2rem;
				}
			}

			&__value {
				font-size: 0.37rem;
				color: #919499;
			}
		}
	}
}
</style>
